import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  markFormsAsTouched(formGroup: UntypedFormGroup): void {
    for (const key in formGroup.controls) {
      if (formGroup.controls[key] instanceof UntypedFormGroup) {
        this.markFormsAsTouched(formGroup.controls[key] as UntypedFormGroup);
      } else {
        (formGroup.controls[key] as UntypedFormControl).markAsTouched();
        (formGroup.controls[key] as UntypedFormControl).updateValueAndValidity();
      }
    }
  }
}
